module.exports = __webpack_public_path__ + "img/so.5d09b7df.svg";